var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fs-address-bar mb-2"},[_c('span',{staticClass:"mr-2"},[_vm._v("Address")]),_c('input',{staticClass:"fs-inset-pane w-100 px-2",attrs:{"type":"text"},domProps:{"value":_vm.cleanURL}})])}
var staticRenderFns = []

export { render, staticRenderFns }